import { ListItem, ListItemText, Menu } from '@material-ui/core';
import styled from 'styled-components';
import {SvgIconFillColorByCurrentApp, SvgIconFillColorOpenByCurrentApp, UserIconBoxShadowByCurrentApp, UserIconBoxShadowHoverByCurrentApp} from '../../utils/get-app-env';

export const UserIconWrapper = styled.div<{ onClick: any, isMenuOpen: boolean }>`
  position: absolute;
  top: 10px;
  right: 25px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  box-shadow: ${UserIconBoxShadowByCurrentApp()};
  cursor: pointer;
  
  transition: all .5s ease;

  svg {
    width: 40px;
    height: 40px;
    fill: ${props => props.isMenuOpen ? SvgIconFillColorOpenByCurrentApp() : SvgIconFillColorByCurrentApp()};
  }

  :hover {
    box-shadow: ${UserIconBoxShadowHoverByCurrentApp()};

    svg {
      transition: all .5s ease;
      fill: ${SvgIconFillColorByCurrentApp()};
    }
  }
`;

export const StyledMenu = styled(Menu)`
  section {
    text-align: center;
    padding: 8px 0;
  }

  li:hover {
    background-color: rgb(34 59 107 / 7%);

    button {
      color: #f45248;
    }
  }
`;

export const MenuExitButton = styled(ListItem)`
  *:hover {
    color: rgba(255, 0, 0, 0.5);
  }
`;

export const TextListItem = styled(ListItemText)`
  :hover {
    cursor: pointer;
  }
`